// US 提现三个页面的 rem 适配 mixin。
// 这些页面的 CSS 全部按 1rem=100px（720 设计稿）标注，而 SPA 的 App.vue 用的是 1rem=10px，
// 两套基准差 10 倍。这里在页面挂载时接管根 font-size，卸载时还原成 App.vue 的值，
// 这样整套 CSS 一个数值都不用改。App.vue 的 resize 监听先注册、本 mixin 后注册，
// resize 时本 mixin 后执行、值覆盖它，页面停留期间由本 mixin 主导。
export default {
  mounted () {
    this._withdrawOriginalFontSize = document.documentElement.style.fontSize
    this._withdrawSetRem()
    window.addEventListener('resize', this._withdrawSetRem)
    window.addEventListener('orientationchange', this._withdrawSetRem)
  },
  beforeUnmount () {
    window.removeEventListener('resize', this._withdrawSetRem)
    window.removeEventListener('orientationchange', this._withdrawSetRem)
    // 还原为 App.vue 之前设置的值；若原来为空，触发一次 resize 让 App.vue 重新计算
    document.documentElement.style.fontSize = this._withdrawOriginalFontSize || ''
    if (!this._withdrawOriginalFontSize) {
      window.dispatchEvent(new Event('resize'))
    }
  },
  methods: {
    // 竖屏按宽度、横屏按高度取短边为基准，最大 720，1rem = 100px
    _withdrawSetRem () {
      const isLandscape = window.matchMedia('(orientation: landscape)').matches
      const base = isLandscape
        ? (document.documentElement.clientHeight || window.innerHeight)
        : (document.documentElement.clientWidth || window.innerWidth)
      const size = Math.min(base, 720)
      document.documentElement.style.fontSize = size / 7.2 + 'px'
    }
  }
}
